module.exports = __webpack_public_path__ + "static/media/pod.9ea05c1c.svg";